import React from 'react';
import { StorageInfoResponse } from '../../api/fetchStorageInfo';
import { useDispatch } from 'react-redux';
import { toggleStorageModal } from '../../store/actions/session';

// interface StorageInfoResponse {
//     status: string;
// }

const StorageInfo: React.FC<
    StorageInfoResponse & {
        className: string;
        outerClassName?: string;
        statusClassName?: string;
        iconCssClassName?: string;
    }
> = (props) => {
    const {
        storage: { usage, exceeded, max_limit },
    } = props;

    const dispatch = useDispatch();

    const isWithinLimit = usage?.status === 'WITHIN_LIMIT';
    const text = (
        <span>
            {usage?.amount} {usage?.unit}{' '}
            <span className={props.statusClassName ?? ''}>of patient data stored</span>
        </span>
    );

    const openStorageDialog = () => dispatch(toggleStorageModal(true));

    return (
        <div
            className={
                props.outerClassName ??
                `flex my-4 gap-8 items-center rounded-8 px-8 py-4 ${
                    isWithinLimit ? 'bg-darwin-green-bg-light' : 'bg-darwin-accent-light-yellow'
                }`
            }
            onClick={openStorageDialog}
        >
            <div className={props?.iconCssClassName}>
                {isWithinLimit ? (
                    <svg
                        width="18"
                        height="12"
                        viewBox="0 0 18 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.875 8.15625C0.875 6.58203 1.89062 5.21094 3.3125 4.72852C3.3125 4.65234 3.3125 4.57617 3.3125 4.5C3.3125 2.26562 5.11523 0.4375 7.375 0.4375C8.87305 0.4375 10.1934 1.27539 10.8789 2.49414C11.2598 2.21484 11.7422 2.0625 12.25 2.0625C13.5957 2.0625 14.6875 3.1543 14.6875 4.5C14.6875 4.83008 14.6113 5.10938 14.5098 5.38867C16.0078 5.69336 17.125 7.01367 17.125 8.5625C17.125 10.3652 15.6523 11.8125 13.875 11.8125H4.53125C2.5 11.8125 0.875 10.1875 0.875 8.15625Z"
                            fill="#19A66A"
                        />
                    </svg>
                ) : (
                    <svg
                        width="18"
                        height="12"
                        viewBox="0 0 18 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.875 8.15625C0.875 6.58203 1.89062 5.21094 3.3125 4.72852C3.3125 4.65234 3.3125 4.57617 3.3125 4.5C3.3125 2.26562 5.11523 0.4375 7.375 0.4375C8.87305 0.4375 10.1934 1.27539 10.8789 2.49414C11.2598 2.21484 11.7422 2.0625 12.25 2.0625C13.5957 2.0625 14.6875 3.1543 14.6875 4.5C14.6875 4.83008 14.6113 5.10938 14.5098 5.38867C16.0078 5.69336 17.125 7.01367 17.125 8.5625C17.125 10.3652 15.6523 11.8125 13.875 11.8125H4.53125C2.5 11.8125 0.875 10.1875 0.875 8.15625Z"
                            fill="#EDAE0C"
                        />
                    </svg>
                )}
            </div>

            <div className={props.className}>
                <p className="font-400 text-13">Storage: </p>
                <p
                    className={`font-700 text-12 ${
                        isWithinLimit
                            ? 'text-darwin-green-primary'
                            : 'text-darwin-accent-dark-yellow'
                    }`}
                >
                    {text}
                </p>
            </div>
        </div>
    );
};

export default StorageInfo;
